/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js"

import router from '@/router'

export default {
    // JWT
    login({ commit }, payload) {
        console.log('JWT login');

        return new Promise((resolve, reject) => {
            jwt.login(payload.userDetails.email, payload.userDetails.password)
                .then(response => {

                    // If there's user data in response
                    if (response.data.token) {
                        // Update user details
                        commit('UPDATE_USER_INFO', response.data.userData, { root: true })

                        // Set bearer token in axios
                        commit("SET_BEARER", response.data.token)

                        // Set accessToken
                        localStorage.setItem("accessToken", response.data.token)

                        // Navigate User to homepage
                        router.push(router.currentRoute.query.to || '/')
                        resolve(response)
                    } else {
                        reject({ message: "Wrong Email or Password" })
                    }
                })
                .catch(error => { reject(error) })
        })
    },

    fetchAccessToken() {
        return new Promise((resolve) => {
            jwt.refreshToken().then(response => { resolve(response) })
        })
    }
}